import { En } from '../i18n/En';
import { formatDate } from '../i18n/format';
import { t } from '../i18n/t';

export type BookRead = {
  readonly finishedAt: string;
  readonly book: {
    readonly id: string;
    readonly title: string;
    readonly cover: string;
    readonly gloss: string | null | undefined;
  };
};

/**
 * Books read, newest first, with the date and nothing about how (R11). The
 * parent's list on a child's `/account/history`, and an adult's own under
 * their conversations (amendment 2026-09-29): the same rows, told apart only
 * by what the empty list says.
 */
export function BooksRead({
  reads,
  language,
  none,
  titled = true,
}: {
  reads: ReadonlyArray<BookRead>;
  language: string;
  none: 'history-books-none-own' | 'grown-ups-books-none';
  /** For grown-ups puts its own section heading over the list. */
  titled?: boolean;
}) {
  return (
    <>
      {titled && <h3 className="mt-4 font-semibold">{t('history-books-title')}</h3>}
      {reads.length === 0 ? (
        <p className="text-base-content/60 text-sm">{t(none)}</p>
      ) : (
        <ul className="flex flex-col gap-2">
          {reads.map((r, i) => (
            <li key={`${r.book.id}-${i}`} className="flex items-center gap-3">
              <span aria-hidden className="text-2xl">
                {r.book.cover}
              </span>
              <span className="flex-1 font-medium">
                <En>{r.book.title}</En>
                {r.book.gloss && (
                  <span lang={language} className="text-base-content/60">
                    {' · '}
                    {r.book.gloss}
                  </span>
                )}
              </span>
              <span className="text-base-content/60 text-sm">{formatDate(new Date(r.finishedAt))}</span>
            </li>
          ))}
        </ul>
      )}
    </>
  );
}
